import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const HeroSection = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1567027911710-181d48eb5d65?q=80&w=2000&auto=format&fit=crop"
          alt="Vue aérienne de la forêt française - Sylva Invest spécialiste du foncier forestier"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-forest/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 text-center text-white">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-xs uppercase tracking-[0.25em] text-gold mb-6 font-sans font-semibold"
        >
          Estimation · Transactions · Valorisation · Remembrement
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="font-serif text-4xl sm:text-5xl lg:text-7xl font-medium tracking-tight leading-[1.1] mb-8"
          data-testid="hero-headline"
        >
          Recomposer le Foncier Forestier.
          <br />
          Créer une Valeur Durable.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="font-sans text-base md:text-lg max-w-2xl mx-auto mb-10 text-white/90 leading-relaxed"
          data-testid="hero-subheadline"
        >
          Sylva Invest accompagne les propriétaires dans l'estimation, la vente et la valorisation de leurs actifs forestiers, ainsi que dans les situations de succession, d'indivision et de regroupement foncier.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <a
            href="/estimation-foret"
            className="btn-primary bg-white text-forest hover:bg-gold hover:text-forest"
            data-testid="hero-cta-primary"
          >
            Estimer ma forêt
          </a>
          <a
            href="#contact"
            className="btn-primary bg-gold text-forest hover:bg-white hover:text-forest"
            data-testid="hero-cta-secondary"
          >
            Parler de mon projet
          </a>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="mt-12 text-sm text-white/70"
        >
          Activité immobilière réglementée (Carte T) · Conseil en foncier forestier
        </motion.p>

        {/* Scroll indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
          className="absolute bottom-10 left-1/2 -translate-x-1/2"
        >
          <ChevronDown className="animate-bounce text-white/50" size={32} />
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
